import React, { useContext } from "react";
import CourseGrid from "../components/home/CourseGrid";
import LiveDisciplineNotice from "../components/home/LiveDisciplineNotice";
import { CourseAccessesContext } from "../context/CourseAccessesContext";
import { AuthContext } from "../context/AuthContext";
import simboloLight from "../assets/rebrand/simbolo-light.png";

const PanelHome = () => {
  const { course_accesses } = useContext(CourseAccessesContext);
  const { user } = useContext(AuthContext);

  const firstName = user?.nombre ? user.nombre.split(" ")[0] : null;

  return (
    <div id="panel-home">
      <div className="container-fluid pe-0 py-3">
        <div className="px-2">
        <div
          className="px-4 px-5 py-5 mb-5 d-flex align-items-center justify-content-between"
          style={{
            background: "linear-gradient(135deg, #4F2A3B 0%, #6B3440 40%, #FFB66B 100%)",
            borderRadius: "16px",
          }}
        >
          <div>
            <p
              className="mb-1"
              style={{
                fontFamily: "'Apfel Grotezk', sans-serif",
                color: "#F2EEE8",
                opacity: 0.75,
                fontSize: "0.85rem",
                letterSpacing: "0.12em",
                textTransform: "uppercase",
              }}
            >
              Move · Transform · Lead
            </p>
            <h1
              style={{
                fontFamily: "'PPFragment Glare', serif",
                color: "#F2EEE8",
                fontSize: "clamp(1.6rem, 4vw, 2.6rem)",
                marginBottom: 0,
              }}
            >
              {firstName ? `Bienvenida, ${firstName}.` : "Bienvenida."}
            </h1>
          </div>
          <img
            src={simboloLight}
            alt=""
            aria-hidden="true"
            style={{ width: "clamp(52px, 6vw, 88px)", opacity: 0.85 }}
          />
        </div>
        </div>
        {/*<LiveDisciplineNotice />*/}
        <CourseGrid isPanel course_accesses={course_accesses} />
      </div>
    </div>
  );
};

export default PanelHome;
